'use strict';

module.exports = () => {

    function initSlider($pane) {
        const $slider = $pane.find('.projects__slider');
        const $nav = $pane.find('.projects__nav');

        if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
                slidesToShow: 1,
                arrows: true,
                dots: true,
                adaptiveHeight: true,

                appendArrows: $nav,
                appendDots: $nav,

                prevArrow: '<button class="slick-prev custom-arrow"></button>',
                nextArrow: '<button class="slick-next custom-arrow"></button>',
            });
        } else {
            $slider.slick('setPosition');
        }
    }

    const $firstPane = $('.projects__tabs-pane.active');
    initSlider($firstPane);


    $('.projects__tabs-btn').on('click', function () {
        const tabId = $(this).data('tab');

        $('.projects__tabs-btn').removeClass('active');
        $(this).addClass('active');

        $('.projects__tabs-pane').removeClass('active');
        const $activePane = $('.projects__tabs-pane[data-tab="' + tabId + '"]');
        $activePane.addClass('active');

        initSlider($activePane);
    });

}